import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { usePergunta } from "../contexts/PerguntaContext";
import { animacaoDoApp } from "../lib/animacoes";

interface IndicadorCarregandoProps {
  icone: React.ReactNode;
  textoChave: string;
  // App com animação própria: ela ocupa o lugar do ícone e dos pontinhos.
  slugAmigavel?: string;
}

// Mostra o que está acontecendo enquanto a IA responde, em vez de só três pontinhos.
const IndicadorCarregando: React.FC<IndicadorCarregandoProps> = ({
  icone,
  textoChave,
  slugAmigavel,
}) => {
  const { t } = useTranslation();
  const { appName } = usePergunta();
  const [falhou, setFalhou] = useState(false);
  const animacao = falhou ? null : animacaoDoApp(slugAmigavel);

  return (
    <div className="resposta-gpt flex w-full altura-minima assistente">
      {animacao ? (
        // Dentro do mesmo círculo do ícone das respostas: parece o ícone ganhando vida.
        <div className="icone-assistente">
          <span
            className="animacao-carregando"
            style={{ "--ocupacao": animacao.ocupacao } as React.CSSProperties}
          >
            <video
              src={animacao.src}
              autoPlay
              loop
              muted
              playsInline
              aria-hidden="true"
              onError={() => setFalhou(true)}
            />
          </span>
        </div>
      ) : (
        // Sem animação própria: o ícone parado com um anel girando em volta do círculo.
        <div className="icone-assistente">
          <span className="icone-girando">{icone}</span>
        </div>
      )}
      <div className="flex-1 carregando-resposta">
        <p className="texto-carregando texto-brilhando">{t(textoChave, { appName })}</p>
      </div>
    </div>
  );
};

export default IndicadorCarregando;
